document.addEventListener("DOMContentLoaded", function() {
    // Select all images on the page that do not have 'loading="lazy"'
    const images = document.querySelectorAll('img:not([loading="lazy"])');

    // Loop through each image and set 'loading="lazy"'
    images.forEach(function(img) {
        img.setAttribute('loading', 'lazy');
    });

    // For iframes (like product videos or embedded content)
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
        iframe.setAttribute('loading', 'lazy');
    });
});
